/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmdk_Link_Web_Or_PdfInputs */

const en_cmdk_link_web_or_pdf = /** @type {(inputs: Cmdk_Link_Web_Or_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to web page or PDF`)
};

const es_cmdk_link_web_or_pdf = /** @type {(inputs: Cmdk_Link_Web_Or_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlazar una página web o PDF`)
};

/**
* | output |
* | --- |
* | "Link to web page or PDF" |
*
* @param {Cmdk_Link_Web_Or_PdfInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cmdk_link_web_or_pdf = /** @type {((inputs?: Cmdk_Link_Web_Or_PdfInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmdk_Link_Web_Or_PdfInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_cmdk_link_web_or_pdf(inputs)
	return en_cmdk_link_web_or_pdf(inputs)
});